import de from '../translations/de.json';
import fr from '../translations/fr.json';
import it from '../translations/it.json';
import en from '../translations/en.json';

export const LANGUAGES = {
  de: 'de',
  fr: 'fr',
  it: 'it',
  en: 'en',
};

export const TRANSLATIONS = {
  de,
  fr,
  it,
  en,
};
